import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconEnrolment: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M19 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2ZM10 4H14V7.13L12.55 6.13C12.3867 6.02247 12.1955 5.96516 12 5.96516C11.8045 5.96516 11.6133 6.02247 11.45 6.13L10 7.13V4ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H8V9C8.00048 9.1809 8.05003 9.35829 8.14336 9.51326C8.2367 9.66823 8.37032 9.79498 8.53 9.88C8.68637 9.96029 8.86115 9.99795 9.03671 9.98917C9.21227 9.98039 9.38242 9.92549 9.53 9.83L12 8.2L14.45 9.83C14.6004 9.92905 14.7748 9.98565 14.9547 9.99381C15.1346 10.002 15.3133 9.96142 15.4721 9.87641C15.6308 9.7914 15.7637 9.66509 15.8566 9.51083C15.9495 9.35657 15.9991 9.18008 16 9V4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V19Z"
        fill="#262626"
      />
    </Icon>
  );
};

export default IconEnrolment;
